module.exports = __webpack_public_path__ + "static/img/shezhi_zengli.fd9b405e.png";